<template>
  <div>
    <el-dialog
      title="主页"
      :visible="pageMixShow"
      width="1000px"
      @close="close"
      @open="openInit"
      append-to-body
    >
      <div class="localsList mix-wrap-action">
        <p class="batch-p">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <page-select
            v-model="comValObj.page_id"
            :page-list="pageList"
            :account-id="account"
            :target-user-id="targetUserId"
            :show-set-status="false"
            @change="changePages"
            @refresh-pages="$emit('refresh-pages')"
          ></page-select>
          <span style="margin-left: 20px">Instagram账号：</span>
          <el-select
            v-model="comValObj.instagram_actor_id"
            placeholder="请选择Instagram账号"
            @change="(val) => batchChange('instagram_actor_id', val)"
          >
            <el-option
              :label="instagrams.username"
              :value="instagrams.id"
              v-for="instagrams in pageInstagramsList"
              :key="instagrams.id"
              style="height: 70px"
            >
              <div class="pageItems">
                <div class="pageImg">
                  <el-image :src="instagrams.profile_pic"></el-image>
                </div>
                <div class="pageMsg">
                  <p>{{ instagrams.username }}</p>
                  <div>编号：{{ instagrams.id }}</div>
                </div>
              </div>
            </el-option>
          </el-select>
        </p>
        <el-checkbox-group
          v-model="checkedDatas"
          @change="
            (val) =>
              handleCheckedDatasChange(['page_id','instagram_actor_id'], pageMsgList, val)
          "
        >
          <el-checkbox v-for="item in dataList" :label="item.id" :key="item.id">
            <el-tooltip v-if="item.name" :content="item.name">
              <span class="mixName">{{ item.name }}</span>
            </el-tooltip>
            <span style="margin-left:20px">主页：</span>
            <page-select
              v-model="item.page_id"
              :page-list="pageList"
              :account-id="account"
              :target-user-id="targetUserId"
              :show-set-status="false"
              :load-pages="false"
              @change="(val) => selectPage(item, val)"
              @refresh-pages="$emit('refresh-pages')"
            ></page-select>
            <span style="margin-left: 20px">Instagram账号：</span>
            <el-select
              v-model="item.instagram_actor_id"
              placeholder="请选择Instagram账号"
            >
              <el-option
                :label="instagrams.username"
                :value="instagrams.id"
                v-for="instagrams in item.pageInstagramsList"
                :key="instagrams.id"
                style="height: 70px"
              >
                <div class="pageItems">
                  <div class="pageImg">
                    <el-image :src="instagrams.profile_pic"></el-image>
                  </div>
                  <div class="pageMsg">
                    <p>{{ instagrams.username }}</p>
                    <div>编号：{{ instagrams.id }}</div>
                  </div>
                </div>
              </el-option>
            </el-select>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageSelect from '@/components/PageSelect/index.vue';
import { pageInstagrams } from '@/api/creatAd';
import mixBatchOperate from '@/views/adManagement/assets/js/mixBatchOperate';

export default {
  props: ['pageMixShow', 'pageMsgList', 'pageList', 'account', 'targetUserId'],
  mixins: [mixBatchOperate],
  components: { PageSelect },
  data() {
    return {
      initData: this.$store.getters.initData,
      list: [],
      dataList: JSON.parse(JSON.stringify(this.pageMsgList)),
      pageInstagramsList: [],
      msg: {},
    };
  },
  methods: {
    close() {
      this.$emit('update:pageMixShow', false);
    },
    openInit() {},
    sure() {
      this.$emit('setMixMsg', 'page', this.dataList);
      this.close();
    },
    changePages(v) {
      pageInstagrams({ pageId: v, adAccountId: this.account }, this.targetUserId).then((res) => {
        const instagrams = res.data || [];
        const last = instagrams[instagrams.length - 1];
        this.pageInstagramsList = instagrams;
        this.$set(this.comValObj, 'instagram_actor_id', last ? last.id : '');
        this.dataList.map((k, index) => {
          if (this.checkedDatas.includes(k.id)) {
            this.$set(this.dataList[index], 'pageInstagramsList', instagrams);
            this.dataList[index].instagram_actor_id = last ? last.id : '';
          }
        });
      });
      this.batchChange('page_id', v);
    },
    selectPage(item, v) {
      pageInstagrams({ pageId: v, adAccountId: this.account }, this.targetUserId).then((res) => {
        const instagrams = res.data || [];
        const last = instagrams[instagrams.length - 1];
        item.instagram_actor_id = last ? last.id : '';
        this.$set(item, 'pageInstagramsList', instagrams);
      });
    },
  },
  watch: {
    pageMsgList: {
      handler() {
        this.dataList = JSON.parse(JSON.stringify(this.pageMsgList));
      },
    },
  },
};
</script>
<style lang="scss" scope>
.localsList {
  max-height: 700px;
  overflow-x: hidden;
  overflow-y: auto;
  .el-row {
    margin-bottom: 10px;
  }
}
</style>
